import { MovementEntity } from '../entities/movement-entity';

export default class State {
  items: Array<MovementEntity> = [];
}
